import styles from '@src/components/FJModals/FJShareModal/FJShareContent/FJCommon.module.less';
import FJCheckBox1 from '@src/components/FJCheckBox/FJCheckBox1.tsx';
import FJCheckBox from '@src/components/FJCheckBox/FJCheckBox.tsx';
import FJLocalStore from '@src/store/FJLocalStore';
import { useMemo } from 'react';

interface Props {
    targets: string[];
    target: string;
    onChange: (target: string) => void;
    checkBoxStyleType: 'circle' | 'round';
    disableReselect?: boolean;
}

const FJCheckBoxGroup = ({ targets, target, checkBoxStyleType, disableReselect = false, onChange }: Props) => {
    const CheckBox = useMemo(() => {
        return checkBoxStyleType === 'circle' ? FJCheckBox1 : FJCheckBox;
    }, [checkBoxStyleType]);

    return (
        <div className={styles.check_box_list}>
            {targets.map(item => (
                <CheckBox
                    key={item}
                    value={FJLocalStore._(item)}
                    dataChange={() => onChange(item)}
                    selected={target === item}
                    disableReselect={disableReselect}
                />
            ))}
        </div>
    );
};

export default FJCheckBoxGroup;
